module.exports = __webpack_public_path__ + "img/streetsweeper_parked.669da43f.svg";